import { DeleteOutlined } from '@ant-design/icons';
import { Button, Flex, Space, Tooltip, Typography } from 'antd';

import type { ModelUserIntegration } from '@app/api/Users';
import { Avatar } from '@app/components/Avatar';
import {
  EMAIL_HANDLER,
  NO_NAME_LABEL,
  U_ACTION,
  U_INTEGRATIONS,
  U_KEY,
  U_LOGIN,
  U_SALES_FUNNELS,
  U_STATUS,
} from '@app/constants';
import { IntegrationStatus } from '@app/shared/ui/IntegrationStatus';
import { SocialIntegrationIcon } from '@app/shared/ui/SocialIntegrationIcon';

const { Text } = Typography;

export const adaptDataToTable = (
  integrations: ModelUserIntegration[] | undefined,
  setIsDeleteModalOpen: (status: boolean) => void,
  setSelectedRowKeys: (Ids: string[]) => void
) => {
  return integrations?.map((integration) => {
    const {
      Id,
      SocialType,
      AccountLogin,
      AccountName,
      IntegrationName,
      Status,
      Avatar: AvatarPhoto,
      SalesFunnel,
      SalesFunnelStage,
    } = integration;

    return {
      [U_KEY]: String(Id),
      [U_INTEGRATIONS]: (
        <Flex
          style={{ minWidth: '180px' }}
          data-testid="integration-name"
          gap={12}
          align="center"
        >
          <SocialIntegrationIcon type={SocialType} size="lg" />

          <div>
            {AccountName || NO_NAME_LABEL} <br />
          </div>
        </Flex>
      ),
      [U_LOGIN]: (
        <Flex data-testid="integration-account" gap={10} align="center">
          <Avatar
            src={AvatarPhoto}
            nameFirst={IntegrationName}
            className="avatar"
            size={24}
          />
          <div>
            <Text strong>{IntegrationName}</Text>
            {AccountLogin && (
              <>
                <br />{' '}
                {SocialType === EMAIL_HANDLER
                  ? AccountLogin
                  : `+${AccountLogin}`}
              </>
            )}
          </div>
        </Flex>
      ),
      [U_SALES_FUNNELS]: (
        <div className="sales-funnel-column" data-testid="integration-funnel">
          {SalesFunnel && SalesFunnelStage
            ? `${SalesFunnel.Name}, ${SalesFunnelStage.Name}`
            : ''}
        </div>
      ),
      [U_STATUS]: (
        <div className="status-column" data-testid="status-integration">
          <IntegrationStatus status={Status} />
        </div>
      ),
      [U_ACTION]: (
        <Space>
          <Tooltip title="Удалить интеграцию">
            <Button
              icon={<DeleteOutlined />}
              onClick={() => {
                setSelectedRowKeys([String(Id)]);
                setIsDeleteModalOpen(true);
              }}
              data-testid="delete-integration-icon"
            />
          </Tooltip>
        </Space>
      ),
    };
  });
};
